var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_751",
    "data-name": "Grupo 751",
    transform: "translate(-725 -687)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(725 687)",
    fill: "#009ebe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_735",
    "data-name": "Grupo 735",
    transform: "translate(69.483 -111.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_96",
    "data-name": "Caminho 96",
    d: "M11.069,0H7.69A1.6,1.6,0,0,0,6,1.69V25.344a1.6,1.6,0,0,0,1.69,1.69h3.379a1.6,1.6,0,0,0,1.69-1.69V1.69A1.6,1.6,0,0,0,11.069,0Z",
    transform: "translate(673.138 809.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_97",
    "data-name": "Caminho 97",
    d: "M5.069,10H1.69A1.6,1.6,0,0,0,0,11.69v6.758a1.6,1.6,0,0,0,1.69,1.69H5.069a1.6,1.6,0,0,0,1.69-1.69V11.69A1.6,1.6,0,0,0,5.069,10Z",
    transform: "translate(669 815.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_98",
    "data-name": "Caminho 98",
    d: "M17.069,5H13.69A1.6,1.6,0,0,0,12,6.69V21.9a1.6,1.6,0,0,0,1.69,1.69h3.379a1.6,1.6,0,0,0,1.69-1.69V6.69A1.6,1.6,0,0,0,17.069,5Z",
    transform: "translate(677.275 812.449)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashs);
export default __webpack_public_path__ + "static/media/dashs.b8f9d7ad97a6df77a033d099f92b746b.svg";
export { ForwardRef as ReactComponent };